var _window;
import { fromJS, List, Map } from "immutable";
import { createSelector } from "reselect";
var config = ((_window = window) === null || _window === void 0 ? void 0 : _window.config) || {};
export function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    default:
      return state;
  }
}
export var getAmsBaseUrl = function getAmsBaseUrl(state) {
  var _state$config;
  return state === null || state === void 0 || (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.amsBaseUrl;
};
export var getLocales = function getLocales(state) {
  var _state$config$locales, _state$config2;
  return (_state$config$locales = state === null || state === void 0 || (_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : _state$config2.locales) !== null && _state$config$locales !== void 0 ? _state$config$locales : [];
};
export var getInitialLocale = function getInitialLocale(state) {
  var _state$config3;
  return state === null || state === void 0 || (_state$config3 = state.config) === null || _state$config3 === void 0 ? void 0 : _state$config3.initialLocale;
};
export var getErrorPageUrl = function getErrorPageUrl(state) {
  var _state$config4;
  return state === null || state === void 0 || (_state$config4 = state.config) === null || _state$config4 === void 0 ? void 0 : _state$config4.errorPageUrl;
};
export var getAnalyticsEnv = function getAnalyticsEnv(state) {
  var _state$config5;
  return (state === null || state === void 0 || (_state$config5 = state.config) === null || _state$config5 === void 0 || (_state$config5 = _state$config5.analytics) === null || _state$config5 === void 0 ? void 0 : _state$config5.env) || "dev";
};
export var getAnalyticsGeoRegion = function getAnalyticsGeoRegion(state) {
  var _state$config6;
  return (state === null || state === void 0 || (_state$config6 = state.config) === null || _state$config6 === void 0 || (_state$config6 = _state$config6.analytics) === null || _state$config6 === void 0 ? void 0 : _state$config6.geoRegion) || "na";
};
export var getFixedCoStationId = function getFixedCoStationId(state) {
  var _state$config7;
  return (state === null || state === void 0 || (_state$config7 = state.config) === null || _state$config7 === void 0 ? void 0 : _state$config7.fixedCoStationId) || undefined;
};
var getFormConfigurations = function getFormConfigurations(state) {
  var _state$config8;
  return state === null || state === void 0 || (_state$config8 = state.config) === null || _state$config8 === void 0 ? void 0 : _state$config8.formConfigurations;
};
export var newGetFormConfigurations = function newGetFormConfigurations(groupName) {
  return createSelector([getFormConfigurations], function (defaultConfigurations) {
    var configMap = defaultConfigurations ? fromJS(defaultConfigurations) : Map();
    return configMap.get(groupName, List());
  });
};